export default __webpack_public_path__ + "static/media/alliedHangers5.38da8e0e.jpg";